import React from 'react';
import { Check } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { WHATSAPP_URL, PRICE, LOGO_URL } from '../data/site';
const includes = ['Sesión personalizada', 'Exploración de tu situación actual', 'Identificación de áreas de bloqueo', 'Claridad sobre tu siguiente paso', 'Hoja de ruta inicial', 'Guía de Reconexión Energética'];
export function PricingSection() {
  return <section id="reserva" className="scroll-mt-4 bg-ivory px-6 py-20 sm:py-28" data-id="element-213" data-mp="1ncn11o6huobm">
      <div className="mx-auto max-w-2xl" data-id="element-214" data-mp="1s82dcbousc5x">
        <Reveal data-id="element-215" data-mp="1x8qa7dzrjn82">
          <p className="text-center text-[10px] font-semibold uppercase tracking-[0.28em] text-gold-dark sm:text-[11px]" data-id="element-216" data-mp="1x86wyal25n0d">
            Tu siguiente paso
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-217" data-mp="2uyubwquc746">
          <div className="relative mt-8 overflow-hidden rounded-[2rem] border border-gold/45 bg-cream px-7 py-11 text-center shadow-lift sm:px-12 sm:py-14" data-id="element-218" data-mp="2vqs9e7wugxm">
            {/* Fine gold corner details */}
            <span className="pointer-events-none absolute left-5 top-5 h-8 w-8 rounded-tl-2xl border-l border-t border-gold/60" aria-hidden="true" data-id="element-219" data-mp="1mhq069cetegb" />
            <span className="pointer-events-none absolute right-5 top-5 h-8 w-8 rounded-tr-2xl border-r border-t border-gold/60" aria-hidden="true" data-id="element-220" data-mp="1cq3l21wyav8a" />
            <span className="pointer-events-none absolute bottom-5 left-5 h-8 w-8 rounded-bl-2xl border-b border-l border-gold/60" aria-hidden="true" data-id="element-221" data-mp="25g2bo1qsn0f2" />
            <span className="pointer-events-none absolute bottom-5 right-5 h-8 w-8 rounded-br-2xl border-b border-r border-gold/60" aria-hidden="true" data-id="element-222" data-mp="1vgtmdm6vi9z1" />

            <img src={LOGO_URL} alt="" aria-hidden="true" className="mx-auto w-32 sm:w-40" data-id="element-223" data-mp="k1xz5bu5v06v" />

            <h2 className="mt-5 font-serif text-2xl font-light uppercase tracking-[0.12em] text-ink sm:text-3xl" data-id="element-224" data-mp="fzb3t0ya6x4x">
              La Herradura Dorada
            </h2>
            <p className="mt-3 text-[11px] uppercase tracking-[0.2em] text-ink-muted" data-id="element-225" data-mp="mftdvnz29719">
              Sesión privada 1:1 · 45 minutos · Online
            </p>

            <div className="rule-gold my-8" aria-hidden="true" data-id="element-226" data-mp="ciolv7ijahcj">
              <span className="text-xs text-gold" data-id="element-227" data-mp="cgu0xt79ip8g">✦</span>
            </div>

            <ul className="mx-auto max-w-sm space-y-3 text-left" data-id="element-228" data-mp="3uvmr9ty3i2e3">
              {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-229" data-mp="3is4zs2dyms1">
                  <Check className="mt-1 h-4 w-4 flex-shrink-0 text-gold-dark" strokeWidth={2.5} aria-hidden="true" data-id="element-230" data-mp="3kz0777dlffd4" />
                  <span className="text-[16.5px] leading-relaxed text-ink-soft" data-id="element-231" data-mp="3bxa7le9k5a49">
                    {item}
                  </span>
                </li>)}
            </ul>

            <p className="mt-10 font-serif text-5xl font-light leading-none text-gold-dark sm:text-6xl" data-id="element-232" data-mp="2xatmj8r2uab6">
              {PRICE}
            </p>

            <div className="mt-9" data-id="element-233" data-mp="2sdble4jawzdq">
              <CtaButton href={WHATSAPP_URL} size="lg" pixelEvent="InitiateCheckout" pixelParams={{
              content_name: 'La Herradura Dorada — 45 min',
              source: 'pricing'
            }} data-id="element-234" data-mp="2secyeejvnvy3">
                Quiero mi Herradura Dorada
              </CtaButton>
            </div>

            <p className="mt-6 text-[14px] leading-relaxed text-ink-muted" data-id="element-235" data-mp="3b8rzc9pr1yok">
              Los espacios son limitados para poder mantener la experiencia
              personalizada.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}